

















































import { Cadastros, TotalAssinantes } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import CardIcon from "../../CardIcon.vue";

@Component({
  components: { CardIcon },
})
export default class Resumo extends Vue {
  deltaAssinantes: number | null = null;
  totalAssinantes: number | null = null;
  totalUsuariosAtivos: number | null = null;
  totalCadastros: number | null = null;

  @Prop({ default: false }) readonly loadingAssinantes!: boolean;
  @Prop() readonly assinantes!: TotalAssinantes[];

  @Prop({ default: false }) readonly loadingCadastros!: boolean;
  @Prop() readonly cadastros!: Cadastros[];

  mounted() {
    this.onAssinantesChange(this.assinantes);
  }

  @Watch("assinantes")
  onAssinantesChange(val: TotalAssinantes[]) {
    this.limparAssinantes();
    if (val) {
      const preenchidos = val.filter((x) => x.totalpago);
      if (preenchidos.length > 0) {
        const ultimo = preenchidos[preenchidos.length - 1];

        this.totalAssinantes = ultimo.totalpago;
        this.totalUsuariosAtivos = ultimo.total;
        this.deltaAssinantes = this.totalAssinantes - preenchidos[0].totalpago;
      }
    }
  }

  @Watch("cadastros")
  onCadastrosChange(val: Cadastros[]) {
    this.totalCadastros = null;
    if (val) {
      this.totalCadastros = val
        .map((x) => (x.quantidadeSite ?? 0) + (x.quantidadeApp ?? 0))
        .reduce((total, item) => total + item);
    }
  }

  limparAssinantes() {
    this.deltaAssinantes =
      this.totalAssinantes =
      this.totalUsuariosAtivos =
        null;
  }
}
